import styled from "@emotion/styled";
import { sub } from "date-fns";
import { useState } from "react";
import SelectBox, { menuItemType } from "./selectBox";
import { SelectChangeEvent } from "@mui/material";
import { useI18n } from "../locales";

interface PeriodProps {
  startDate?: Date | null;
  endDate?: Date | null;
  setStartDate: any;
  setEndDate: any;
  width?: any;
  withoutTitle?: boolean;
}

// 기간 선택하는 selectBox
const PeriodForCalendar: React.FC<PeriodProps> = (props) => {
  const { t } = useI18n();
  const { setStartDate, setEndDate, width, withoutTitle } = props;
  const [open, setOpen] = useState(false);
  const [filter, setFilter] = useState(0);
  
  const menuItems: menuItemType[] = [
    { value: 0, title: t.statistics.selectPeriodPlaceholder },
    { value: 30, title: t.statistics.oneMonth },
    { value: 90, title: t.statistics.threeMonths },
    { value: 180, title: t.statistics.sixMonths },
    { value: 364, title: t.statistics.oneYear },
  ];

  const handleChange = (event: SelectChangeEvent) => {
    const value = event.target.value;
    setFilter(Number(value));

    if (value) {
      setStartDate(sub(new Date(), { days: Number(value) }));
      setEndDate(new Date());
    }
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleOpen = () => {
    setOpen(true);
  };

  return (
    <Container
      style={{
        width: width ? width : "175px",
      }}
    >
      <SelectBox
        title={withoutTitle ? undefined : t.statistics.selectPeriod}
        open={open}
        handleChange={handleChange}
        handleClose={handleClose}
        handleOpen={handleOpen}
        filter={filter}
        menuItems={menuItems}
        width={width ? width : 175}
        mr="0"
        srLabel={t.statistics.selectPeriod}
      />
    </Container>
  );
};

export default PeriodForCalendar;

const Container = styled.div``;
